import packingRequest from '../request/packing'

const apiRequest = packingRequest()

export const getShippingCarrier = async (payload) => {
    const {data} = await apiRequest({
        url: `/packing/shipping-carriers/search`,
        method: 'POST',
        data: payload
    })

    return data
}

export const changeStatus = async (id, status) => {
    const {data} = await apiRequest({
        url: `/packing/shipping-carrier/${id}/${status}`,
        method: 'PUT',
        data: ''
    })

    return data
}

export const saveChangeShippingCarrier = async (id, payload) => {
    const {data} = await apiRequest({
        url: `/packing/shipping-carrier/${id}/update`,
        method: 'PUT',
        data: payload
    })

    return data
}

export const getDetailShippingCarrier = (id) => {
    return apiRequest({
        url: `/packing/shipping-carrier/${id}`,
        method: 'GET'
    })
}

export const getCombinationBoxes = async (payload) => {
    const {data} = await apiRequest({
        url: `/packing/shipping-merged-box/search`,
        method: 'POST',
        data: payload
    })

    return data
}

export const saveChangeCombinationBoxes = async (id, payload) => {
    const {data} = await apiRequest({
        url: `/packing/shipping-merged-box/${id}/update`,
        method: 'PUT',
        data: payload
    })

    return data
}

export const addNewCombinationBoxes = async (payload) => {
    const {data} = await apiRequest({
        url: `/packing/shipping-merged-box/`,
        method: 'POST',
        data: payload
    })

    return data
}

export const deleteCombinationBox = async (id) => {
    const {data} = await apiRequest({
        url: `/packing/shipping-merged-box/${id}/delete`,
        method: 'DELETE',
    })

    return data
}

export const getShippingCarrierHistoty = async (payload) => {
    const {data} = await apiRequest({
        url : `/packing/histories/search`,
        method: 'POST',
        data: payload,
    })

    return data
}